import React, { Component } from 'react';
import { connect } from '@souche-f2e/muji';
import { dispatch } from '@@/store';
import { CardPart } from '../../_components/Card';
import Margin from './_components/Margin';
import { WhiteSpace, DetailInfo } from '@/components';
const mapStateToProps = (rootState) => ({
    _state: rootState.moneyDetail,
});
class MoneyManage extends Component {
    componentDidMount() {
        dispatch.moneyDetail.load({});
    }
    render() {
        const { totalMoney, availableMoney, frozenMoney, title, content, } = this.props._state;
        return (<React.Fragment>
        <CardPart tMoney={totalMoney} aMoney={availableMoney} fMoney={frozenMoney}/>
        <WhiteSpace h={20}/>
        <DetailInfo title={title} content={content}/>
        <WhiteSpace />
        <Margin />
     </React.Fragment>);
    }
}
export default connect(mapStateToProps)(MoneyManage);
